import React from 'react';
import { View, StyleSheet, Text, Platform, Image } from 'react-native';
import TargetedMuscleGroupBar from '../components/tracking-targeted-muscle-groups-bar';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import { defaultScale, scaledRatio } from '../../utils/scaling';

const isWeb = Platform.OS === "web";
const isMobileWeb = Platform.OS === "web" && window.innerWidth <= 550;
const isSmallMobile = window.innerWidth <= 350;

class TrackingTargetedMuscleGroups extends React.PureComponent {
 render() {
        const { t, userProfile } = this.props;
        return (
            <View style={styles.container}>
                <Text style={styles.totalWorkouts}>{t('targetedMuscleGroups')}</Text>
                <View style={styles.muscleGroupContainer}>
                    <Image
                        style={[styles.muscleGroupImage, {
                            height: defaultScale(userProfile.gender === 'male' ? 160 : 144),
                            marginTop: defaultScale(10),
                            marginBottom: defaultScale(10),
                        }]}
                        source={userProfile.gender === 'male' ? require('../../assets/images/male-greyscale.png') :
                            require('../../assets/images/female-greyscale.png')}
                    />
                    <TargetedMuscleGroupBar muscleGroupPercentages={this.props.muscleGroupPercentages} />
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Theme.WHITE,
        borderRadius: defaultScale(3),
        marginBottom: defaultScale(15),
    },
    muscleGroupContainer: {
        flexDirection: 'row',
        flex: 1,
    },
    muscleGroupImage: {
        resizeMode: 'contain',
        width: defaultScale(isSmallMobile ? 130 : 160),
        marginRight: isWeb ? 40 : 0,
        marginLeft: isWeb ? 20: 0,
        minWidth: !isWeb && scaledRatio(45, 0.01),
        flex: !isWeb && 1
    },
    totalWorkouts: {
        ...Theme.graphStyle.customMedium16,
        color: Theme.GREY_DARK,
        letterSpacing: 0,
        lineHeight: defaultScale(20),
        marginTop: defaultScale(10),
        marginLeft: defaultScale(20),
    }
});

export default translate(['workoutHistory'])(TrackingTargetedMuscleGroups);
